module.exports = __webpack_public_path__ + "img/2.5495c3ac.png";